module.exports = __webpack_public_path__ + "img/Third-party_Interconnection.6141c4ee.jpg";